import { FormControl } from 'react-bootstrap';
import React from 'react';

export interface SearchControlProps {
  value: string

  setValue(value: string): void
}

export default function SearchControl({ setValue, value }: SearchControlProps) {
  return <FormControl type="text" className="my-2" placeholder="Search"
                      value={value} onChange={event => setValue(event.target.value)}
  />;
}
